import { render, staticRenderFns } from "./bo-image-banner.vue?vue&type=template&id=66641fac"
import script from "./bo-image-banner.vue?vue&type=script&lang=js"
export * from "./bo-image-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports